export const resolutionDef = [
  "360p (640x360)",
  "480p (854x480)",
  "720p (1280x720)",
  "1080p (1920x1080)",
  "1440p (2560x1440)",
  "4K (3840x2160)"
];

export const QP_BY_CODEC = {
  H264: { min: 24, max: 32 },
  H265: { min: 24, max: 32 },
  AV1:  { min: 24, max: 120 },
};

export const HOST_WAIT_MS = 8000;

export const styles = {
  button: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    border: 'none',
    padding: '10px',
    borderRadius: '5px',
    color: 'white',
    cursor: 'pointer',
  },
};

export const SFU_LOADING_TEXT = {
  one:   "Connecting to the host's session…",
  two:   "Joining the live stream…",
  three: "Almost ready…",
};
